import AgGridWrapper from "../../../../../components/AgGridWrapper/AgGridWrapper";
import ActionButtons from "../../../../../components/ActionButtons";
import { changeStatus, setGrid } from "../../utils/slice";
import columnDefs from "./columnDefs";
import { useAppSelector } from "../../../../../utils/hooks/hooks";
import ConfirmModal from "../../../../../components/Modals/ConfirmModal";
import { useState } from "react";

/**
 * Renders a listing component for the RaceManagement module with action buttons.
 *
 * @param {Object} props - The component props.
 * @param {Object} props.moduleInfo - The module information.
 * @param {Function} props.handleViewClick - The function to handle view click use for viewing the details  of a record.
 * @param {Function} props.handleDeleteClick - The function to handle delete click use for delete the details of a record.
 * @param {Function} props.handleEditClick - The function to handle edit click use for editing the details of a record.
 * @return {JSX.Element} The rendered listing component.
 */
const Listing: React.FC<any> = ({
  moduleInfo,
  handleViewClick,
  handleDeleteClick,
  handleEditClick,
}) => {
  const race = useAppSelector(state => state.race);
  const [statusData, setStatusData] = useState<any>();

  /**
 * Renders an ActionRenderer component for the ag grid contains the action buttons.
 *
 * @param {any} props - The props for the component.
 * @return {JSX.Element} The rendered ActionRenderer component.
 */
  const ActionRenderer = (props: any) => {
    return (
      <ActionButtons
        data={props}
        view={{
          action: props?.data?.id !== 0 && handleViewClick,
          permissionKey: `${moduleInfo.permissionKeyPrefix}_DETAILS`,
        }}
        edit={{
          action: props?.data?.id !== 0 && handleEditClick,
          permissionKey: `${moduleInfo.permissionKeyPrefix}_UPDATE`,
        }}
        deleteButton={{
          action: props?.data?.id !== 0 && handleDeleteClick,
          permissionKey: `${moduleInfo.permissionKeyPrefix}_DELETE`,
        }}
      />
    );
  };

  return (
    <>
      <ConfirmModal
        titleName={moduleInfo.title}
        data={statusData}
        close={() => setStatusData(null)}
        callApi={changeStatus}
      />
      <AgGridWrapper
        components={{
          ActionRenderer,
        }}
        rowData={race.rowData}
        onGridReadyWithDispatch={setGrid}
        columnDefs={columnDefs}
        context={{ setStatusData }}
        paginationPageSize={race.perPage}
        cacheBlockSize={race.perPage}
      />
    </>
  );
};

export default Listing;
